import { Spacers } from "../assets/constants/Spacers";
import { aboutMe8, aboutMe9 } from "../assets/images";
import AboutHero from "../components/AboutHero";
import CustomCarousel from "../components/CustomCarousel";
import { RImage } from "../components/RotatingImage";
import styled from "../styled-components";

const { pageContent } = Spacers;


const rotatingImages: RImage[] = [
  {
  src: aboutMe8,
  alt: 'Andrea Lopez standing profile picture.'
  },{
  src: aboutMe9,
  alt: 'Andrea Lopez sitting profile picture.'
  }
]
const About = () => {

  return (
    <PageContainer>
      <PageContentContainer>
         <PageSectionContainer>
          <AboutHero images={rotatingImages}/>
          <CustomCarousel/>
        </PageSectionContainer>
      </PageContentContainer>
    </PageContainer>
  );
};
export default About;

export const CarouselContainerStyles = styled.div`
  display: "flex";
  alignItems: "center";
  justify-content: "center";
  marginBottom: "15px";
  color: black;
  background-color: "#000000";
`;

const PageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const PageContentContainer = styled.div`
  max-width: ${pageContent.maxWidth.px};
  margin: 0 auto;
  padding: ${pageContent.padding.top.px} ${pageContent.padding.horizontal.px} ${pageContent.padding.bottom.px};
  overflow: auto;
`;

const PageSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 25px;
`;